export default "__VITE_ASSET__DFq01oJ$__"